export default __webpack_public_path__ + "static/media/yang-logo.89dd1a76.jpeg";